import { parseISO, format } from 'date-fns';

const FORMAT = 'yyyy-MM-dd';

/**
 * This feature is used to format date
 * 
 * @param {string} date
 * @param {string} [f]
 * @returns {string}
 */

export default function formatDate (date, f = FORMAT) {
    return format(parseISO(date), f);
}

/**
 * Usage example
 * 
 * import formatDate from 'utils/date';
 * 
 * const date = formatDate('2020-01-01', 'yyyy/MM/dd');
 *
 */
